import type { CacheConfig } from '@/types/shared/caching.types'

export const PLATFORM_CACHE_CONFIG: Record<string, CacheConfig> = {
  // Registration Flow
  'register.organization': {
    autosave: true,
    apiCache: false,
    frontendTTL: 30 * 60 * 1000,
    backendTTL: 0,
    storageType: 'sessionStorage',
  },
  'register.single-page': {
    autosave: true,
    apiCache: false,
    frontendTTL: 30 * 60 * 1000,
    backendTTL: 0,
    storageType: 'sessionStorage',
  },

  // Users, Roles, Permissions
  'users.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 2 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['users', 'list'],
  },
  'users.profile-edit': {
    autosave: true,
    apiCache: false,
    frontendTTL: 2 * 60 * 1000,
    backendTTL: 0,
    storageType: 'sessionStorage',
  },
  'users.roles-list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['users', 'roles'],
  },
  'users.permissions': {
    autosave: false,
    apiCache: true,
    frontendTTL: 30 * 60 * 1000,
    backendTTL: 15 * 60 * 1000,
    storageType: 'indexedDB',
    queryKey: ['users', 'permissions'],
  },

  // Menus, Features, Permissions
  'menu.sidebar': {
    autosave: false,
    apiCache: true,
    frontendTTL: 30 * 60 * 1000,
    backendTTL: 15 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['menu', 'sidebar'],
  },
  'menu.features': {
    autosave: false,
    apiCache: true,
    frontendTTL: 30 * 60 * 1000,
    backendTTL: 15 * 60 * 1000,
    storageType: 'indexedDB',
    queryKey: ['menu', 'features'],
  },
  'feature-flags.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['feature-flags', 'list'],
  },

  // Feature Management
  'features.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['features', 'list'],
  },
  'features.analytics': {
    autosave: false,
    apiCache: true,
    frontendTTL: 30 * 60 * 1000,
    backendTTL: 2 * 60 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['features', 'analytics'],
  },

  // Groups Management
  'groups.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 2 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['groups', 'list'],
  },

  // Roles Management
  'roles.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 2 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['roles', 'list'],
  },

  // Menu Management
  'menu.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['menus', 'list'],
  },

  // Dashboard Widgets
  'dashboard-widgets.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['platform-widgets'],
  },

  // Settings Management
  'settings.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 2 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['settings', 'list'],
  },
  'settings.manage': {
    autosave: true,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'sessionStorage',
    queryKey: ['settings', 'manage'],
  },

  // Carousels Management
  'carousels.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['carousels', 'list'],
  },
  'carousels.form': {
    autosave: true,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'sessionStorage',
    queryKey: ['carousels', 'form'],
  },

  // Pilot Access (Support Services)
  'pilot-access.list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 0,
    storageType: 'localStorage',
    queryKey: ['pilot-access', 'list'],
  },
}
